import { Step } from './createCommunitySurvey/createCommunitySurvey.constants'
import { ExperienceOptionsProps } from './createCommunitySurvey/steps/communityCreationExperience/communityCreationExperience.types'

export enum ExperienceList {
  VERY_EASY,
  EASY,
  MEDIUM,
  DIFFICULT,
  VERY_DIFFICULT
}

export enum PostSatisfaction {
  VERY_SATISFIED,
  SATISFIED,
  MEDIUM,
  UNSATISFIED,
  VERY_UNSATISFIED
}

export enum ExperienceLabelDatahub {
  VeryEasy = 'Muito Fácil',
  Easy = 'Fácil',
  Medium = 'Médio',
  Difficult = 'Difícil',
  VeryDifficult = 'Muito Difícil'
}

export enum SatisfactionLabelDatahub {
  VerySatisfied = 'Muito satisfeito',
  Satisfied = 'Satisfeito',
  Medium = 'Nem satisfeito, nem insatisfeito',
  Unsatisfied = 'Insatisfeito',
  VeryUnsatisfied = 'Muito insatisfeito'
}

export const EXPERIENCE_OPTIONS: ExperienceOptionsProps[] = [
  {
    value: ExperienceList.VERY_EASY,
    label: 'community_survey.create_community.experience.very_easy',
    step_to_go: Step.CommunityCreationObjective,
    label_value_datahub: ExperienceLabelDatahub.VeryEasy
  },
  {
    value: ExperienceList.EASY,
    label: 'community_survey.create_community.experience.easy',
    step_to_go: Step.CommunityCreationObjective,
    label_value_datahub: ExperienceLabelDatahub.Easy
  },
  {
    value: ExperienceList.MEDIUM,
    label: 'community_survey.create_community.experience.medium',
    step_to_go: Step.CommunityCreationChallenges,
    label_value_datahub: ExperienceLabelDatahub.Medium
  },
  {
    value: ExperienceList.DIFFICULT,
    label: 'community_survey.create_community.experience.difficult',
    step_to_go: Step.CommunityCreationChallenges,
    label_value_datahub: ExperienceLabelDatahub.Difficult
  },
  {
    value: ExperienceList.VERY_DIFFICULT,
    label: 'community_survey.create_community.experience.very_difficult',
    step_to_go: Step.CommunityCreationChallenges,
    label_value_datahub: ExperienceLabelDatahub.VeryDifficult
  }
]

export const FIRST_POST_SURVEY_BASE_KEY = 'app-membership-consume-first-post'
export const THIRD_POST_SURVEY_BASE_KEY = 'app-membership-consume-third-post'
